export enum WorkDay {
  PART_TIME = "PART_TIME",
  FULL_TIME = "FULL_TIME"
}

export enum WorkDaySpanishTranslation {
  PART_TIME = "Part Time",
  FULL_TIME = "Full Time"
}
